module.exports = __webpack_public_path__ + "fonts/latolightitalic.4d80ac57.ttf";